import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import adminEn from "./en/admin.json";
import candidateEn from "./en/candidate.json";
import commonEn from "./en/common.json";
import adminZh from "./zh-TW/admin.json";
import candidateZh from "./zh-TW/candidate.json";
import commonZh from "./zh-TW/common.json";

export const LOCALE_KEY = "cedar.locale";
export type Locale = "zh-TW" | "en";

function initialLocale(): Locale {
  try {
    const saved = localStorage.getItem(LOCALE_KEY);
    if (saved === "en" || saved === "zh-TW") return saved;
  } catch {}
  return "zh-TW"; // company default (PLAN decision 21)
}

export const i18n = i18next;

export function setupI18n() {
  if (i18next.isInitialized) return i18next;
  i18next.use(initReactI18next).init({
    resources: {
      en: { common: commonEn, candidate: candidateEn, admin: adminEn },
      "zh-TW": { common: commonZh, candidate: candidateZh, admin: adminZh },
    },
    lng: initialLocale(),
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "candidate", "admin"],
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });
  document.documentElement.lang = i18next.language;
  i18next.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
    try {
      localStorage.setItem(LOCALE_KEY, lng);
    } catch {}
  });
  return i18next;
}

export function setLocale(l: Locale) {
  void i18next.changeLanguage(l);
}
